import setting from './setting';
import generate from './generate';
import base from './base';

export default {
    setting ,
    generate ,
    base
}